import { UtmData } from '@websky/graphql';
import { ApolloLink } from 'apollo-boost';
import { UTM_MARKS_KEY, sessionStorageGet, sessionStorageSet } from './cache';

const paximizerUTMLink = new ApolloLink((operation, forward) => {
	const utmMarksFromStorage = sessionStorageGet<UtmData>(UTM_MARKS_KEY);

	if (!utmMarksFromStorage?.source) {
		const searchParams = new URLSearchParams(window.location.search);

		if (searchParams.get('utm_source') === 'cdp') {
			let utmMarks = {};

			for (const [key, value] of searchParams.entries()) {
				if (key.startsWith('utm_')) {
					utmMarks = { ...utmMarks, [key.replace('utm_', '')]: value };
				}
			}

			sessionStorageSet(UTM_MARKS_KEY, utmMarks);
		}
	}

	return forward(operation);
});

export default paximizerUTMLink;
